module.exports = __webpack_public_path__ + "img/close-black.98760eb2.svg";